import Link from "next/link";
import { useRouter } from "next/router";

import { Pagination, Page, PageSimple } from "./styles";

export default function PaginationComponent({ pages, templateHref }) {
  const router = useRouter();
  const path = router.asPath.split("?")[0];
  const { query } = router;
  let { page } = 1;
  if (query.page){
    page = query.page;
  }
  if (page == undefined){
    page = 1;
  } 
  return (
    <>
      
      {pages <= 5 ? // se o totalizador de páginas for menor ou igual a 5, vai mostrar de 1 ao total de páginas em sequência
      <Pagination style={{justifyContent: "center"}} >
      {[...Array(pages)].map((e, i) => (
        <PageSimple key={i} currentPage={page == i + 1} firstPage={!page}>
          <Link
            href={{ pathname: templateHref, query: { ...query, page: i + 1 } }}
            as={{ pathname: path, query: { ...query, page: i + 1 } }}
          >
            <a>{i + 1}</a>
            </Link>
        </PageSimple>
      ))}
      </Pagination>
      : //se não: 
        <Pagination style={{justifyContent: "center"}} >
          <Page currentPage={page} firstPage={!page} style={{display: 'flex'}}>
            { page - 2 > 1 ?
            <>
            <Link
              href={{ pathname: templateHref, query: { ...query, page: 1} }}
              as={{ pathname: path, query: {...query, page: 1} }}
            >
              <a>{1}</a>
            </Link>
            <h1 style={{paddingRight: "2%", color :"#c4c4c4"}}>... </h1>
            </>
            :
            ''
            }
            {page - 2 > 0 ?
            parseInt(page) == pages ?
            <>
            <Link
              href={{ pathname: templateHref, query: { ...query, page: page - 4} }}
              as={{ pathname: path, query: {...query, page: page - 4} }}
            >
              <a>{page - 4}</a>
            </Link>
            <Link
              href={{ pathname: templateHref, query: { ...query, page: page - 3} }}
              as={{ pathname: path, query: {...query, page: page - 3} }}
            >
              <a>{page - 3}</a>
            </Link>
            </>
            :
              parseInt(page) + 1 >= pages ?
              <>
              <Link
                href={{ pathname: templateHref, query: { ...query, page: page - 3} }}
                as={{ pathname: path, query: {...query, page: page - 3} }}
              >
                <a>{page - 3}</a>
              </Link>
              <Link
                href={{ pathname: templateHref, query: { ...query, page: page - 2} }}
                as={{ pathname: path, query: {...query, page: page - 2} }}
              >
                <a>{page - 2}</a>
              </Link>
              </>
              :
              
            <>
            <Link
              href={{ pathname: templateHref, query: { ...query, page: page - 2} }}
              as={{ pathname: path, query: {...query, page: page - 2} }}
            >
              <a>{page - 2}</a>
            </Link>
            <Link
              href={{ pathname: templateHref, query: { ...query, page: page - 1} }}
              as={{ pathname: path, query: {...query, page: page - 1} }}
            >
              <a>{page - 1}</a>
            </Link>
            </>
            :
            page - 1 > 0 ?
            <>
            <Link
              href={{ pathname: templateHref, query: { ...query, page: page - 1} }}
              as={{ pathname: path, query: {...query, page: page - 1} }}
            >
              <a>{page - 1}</a>
            </Link>
            <Link
              href={{ pathname: templateHref, query: { ...query, page: page} }}
              as={{ pathname: path, query: {...query, page: page} }}
            >
              <a style={{backgroundColor: "#343434"}}>{page}</a>
            </Link>
            </>
            :
            <>
            <Link
              href={{ pathname: templateHref, query: { ...query, page: page} }}
              as={{ pathname: path, query: {...query, page: page} }}
            >
              <a style={{backgroundColor: "#343434"}}>{page}</a>
            </Link>
            <Link
              href={{ pathname: templateHref, query: { ...query, page: parseInt(page)+1} }}
              as={{ pathname: path, query: {...query, page: parseInt(page)+1} }}
            >
              <a>{parseInt(page)+1}</a>
            </Link>
            </>
            }
            {parseInt(page) == pages ?
              <>
              <Link
                href={{ pathname: templateHref, query: { ...query, page: page-2} }}
                as={{ pathname: path, query: {...query, page: page-2} }}
              >
                <a>{page-2}</a>
              </Link>
              <Link
                href={{ pathname: templateHref, query: { ...query, page: page-1} }}
                as={{ pathname: path, query: {...query, page: page-1} }}
              >
                <a>{page-1}</a>
              </Link>
              <Link
                href={{ pathname: templateHref, query: { ...query, page: page} }}
                as={{ pathname: path, query: {...query, page: page} }}
              >
                <a style={{backgroundColor: "#343434"}}>{page}</a>
              </Link>
              </>
              :
            parseInt(page) + 1 >= pages ?
            <>
              <Link
                href={{ pathname: templateHref, query: { ...query, page: page - 1} }}
                as={{ pathname: path, query: {...query, page: page - 1} }}
                >
                <a>{page - 1}</a>
              </Link>
              <Link
                href={{ pathname: templateHref, query: { ...query, page: page} }}
                as={{ pathname: path, query: {...query, page: page} }}
              >
                <a style={{backgroundColor: "#343434"}}>{page}</a>
              </Link>
              <Link
                href={{ pathname: templateHref, query: { ...query, page: parseInt(page)+1} }}
                as={{ pathname: path, query: {...query, page: parseInt(page)+1} }}
              >
                <a>{parseInt(page)+1}</a>
              </Link>
              </>
              :
            page - 2 > 0 ?
            <>
            <Link
              href={{ pathname: templateHref, query: { ...query, page: page} }}
              as={{ pathname: path, query: {...query, page: page} }}
            >
              <a style={{backgroundColor: "#343434"}}>{page}</a>
            </Link>
            
            <Link
              href={{ pathname: templateHref, query: { ...query, page: parseInt(page)+1} }}
              as={{ pathname: path, query: {...query, page: parseInt(page)+1} }}
            >
              <a>{parseInt(page)+1}</a>
            </Link>
            <Link
              href={{ pathname: templateHref, query: { ...query, page: parseInt(page)+2} }}
              as={{ pathname: path, query: {...query, page: parseInt(page)+2} }}
            >
              <a>{parseInt(page)+2}</a>
            </Link>
            </>
            :
            page - 1 > 0 ?
            <>
            <Link
              href={{ pathname: templateHref, query: { ...query, page: parseInt(page)+1} }}
              as={{ pathname: path, query: {...query, page: parseInt(page)+1} }}
            >
              <a>{parseInt(page)+1}</a>
            </Link>
            <Link
              href={{ pathname: templateHref, query: { ...query, page: parseInt(page)+2} }}
              as={{ pathname: path, query: {...query, page: parseInt(page)+2} }}
            >
              <a>{parseInt(page)+2}</a>
            </Link>
            <Link
              href={{ pathname: templateHref, query: { ...query, page: parseInt(page)+3} }}
              as={{ pathname: path, query: {...query, page: parseInt(page)+3} }}
            >
              <a>{parseInt(page)+3}</a>
            </Link>
            </>
            :
              
            <>
            <Link
              href={{ pathname: templateHref, query: { ...query, page: parseInt(page)+2} }}
              as={{ pathname: path, query: {...query, page: parseInt(page)+2} }}
            >
              <a>{parseInt(page)+2}</a>
            </Link>
            <Link
              href={{ pathname: templateHref, query: { ...query, page: parseInt(page)+3} }}
              as={{ pathname: path, query: {...query, page: parseInt(page)+3} }}
            >
              <a>{parseInt(page)+3}</a>
            </Link>
            <Link
              href={{ pathname: templateHref, query: { ...query, page: parseInt(page)+4} }}
              as={{ pathname: path, query: {...query, page: parseInt(page)+4} }}
            >
              <a>{parseInt(page)+4}</a>
            </Link>
            </>
            }
            <h1 style={{paddingRight: "2%", color :"#c4c4c4"}}>... </h1>
            <Link
              href={{ pathname: templateHref, query: { ...query, page: pages} }}
              as={{ pathname: path, query: {...query, page: pages} }}
            >
              <a>{pages}</a>
            </Link>
          </Page>
        </Pagination>

      } 
          
  </>
  );
}
//pagination antigo ||
{/* <Pagination>
{[...Array(pages)].map((e, i) => (
  <Page key={i} currentPage={page == i + 1} firstPage={!page}>
    <Link
      href={{ pathname: templateHref, query: { ...query, page: i + 1 } }}
      as={{ pathname: path, query: { ...query, page: i + 1 } }}
    >
      <a>{i + 1}</a>
      </Link>
  </Page>
))}
</Pagination> */}
